export default __webpack_public_path__ + "static/media/chevron-right.52da4f8c.svg";